export const deliverabilitySndsAppGroupIdSndsData = "/deliverability/snds/:app_group_id/snds_data";
